import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import moment from "moment";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";

const CompOffHistroryReport = () => {
  const todayDate = moment().add(1, "months").format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [compOffHistory, setCompOffHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [projectList, setProjectlist] = useState([]);
  const [Status, setStatus] = useState([]);
  const [apiStatus, setApiStatus] = useState(undefined);
  const [respStatus, setRepStatus] = useState(0);
  const [filterFormData, setFilterData] = useState([
    { label: "Project", value: "" },
    { label: "Status", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  console.log("filterFormData", filterFormData);

  const columns = {
    EmployeeName: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    TXNDate: { text: "Applied Date", align: "center", visible: true },
    FromDate: { text: "From Date", align: "center", visible: true },
    ToDate: { text: "To Date", align: "center", visible: true },
    ApplicationStatus: { text: "Status", visible: true },
    ActionByName: { text: "Action By", visible: true },
    ActionDate: { text: "Action Date", align: "center", visible: true },
    ActionRemarks: { text: "Remark", visible: true },
  };
  const defaultColumns = {
    EmployeeName: true,
    ProjectName: true,
    TXNDate: true,
    FromDate: true,
    ToDate: true,
    ApplicationStatus: true,
    ActionByName: true,
    ActionDate: true,
    ActionRemarks: true,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Comp Off History Report"));
  }, []);

  const handleChange = (e, name) => {
    console.log("tests the server", e, name);

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchCompOffLeaveHistory = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}compOffHistory?P_ProjectID=&P_FromDate= ${lastMonthDate}&P_ToDate=${todayDate}&P_ApplicationStatus=`
      );
      if (response.status === 200) {
        setApiStatus(response?.status);
        const compOffData = response?.data?.compOffHistory;
        setCompOffHistory(compOffData);
        // project list
        const projectList = response?.data?.projectList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjectlist(projectList);

        // const status = response.data?.status;
        // setStatus(status);
        const status = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(status);
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  const handleFilterReset = () => {
    // Reset to empty/default values without passing any specific data
    setFilterData([
      { label: "Project", value: "" },
      { label: "Status", value: "" },
      {
        label: "From Date",
        value: moment(lastMonthDate).format("DD-MMM-YYYY"),
      },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ]);
    // Call API with empty/default parameters
    fetchCompOffLeaveHistory();
  };
  useEffect(() => {
    fetchCompOffLeaveHistory();
    console.log("testtt");
  }, []);
  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}compOffHistory?P_ProjectID=${
          filterFormData.find((o) => o.label === "Project")
            ? filterFormData.find((o) => o.label === "Project").value
            : 0
        }&P_FromDate=${
            moment(
              filterFormData.find((o) => o.label === "From Date")?.value
            ).isValid()
              ? moment(
                  filterFormData.find((o) => o.label === "From Date")?.value
                ).format("YYYY-MM-DD")
              : ""
          }&P_ToDate=${
          moment(
            filterFormData.find((o) => o.label === "To Date")?.value
          ).isValid()
            ? moment(
                filterFormData.find((o) => o.label === "To Date")?.value
              ).format("YYYY-MM-DD")
            : ""
        }&P_ApplicationStatus=${
          filterFormData.find((o) => o.label === "Status")
            ? filterFormData.find((o) => o.label === "Status").value
            : 0
        }`
      );
      if (response.status === 200) {
        setApiStatus(response?.status);
        const compOffData = response?.data?.compOffHistory;
        setCompOffHistory(compOffData);
        // project list
        const projectList = response?.data?.projectList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjectlist(projectList);

        // const status = response.data?.status;
        // setStatus(status);
        const status = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(status);
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const formDatas = [
    { name: "Project", type: "Select", options: [...projectList] },
    { name: "Status", type: "Select", options: [...Status] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={compOffHistory}
              columns={columns}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              responseStatus={respStatus}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              isFilterRequired={true}
              formDatas={formDatas}
              handleReset={handleFilterReset}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompOffHistroryReport;
